"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNormalizedActivatedState = getNormalizedActivatedState;
exports["default"] = void 0;

var _getNormalizedMergedState = _interopRequireDefault(require("./getNormalizedMergedState"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getNormalizedActivatedState(state, patch) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var keepFromActivity = config.keepFromActivity || _utils.getDefaultActivityFrom;
  var __activities__ = patch.__activities__;

  var hydratedActivities = (__activities__ || []).map(_utils.hydratedActivityFrom);

  var hydratedPatch = _objectSpread(_objectSpread({}, patch), {}, {
    __activities__: hydratedActivities
  });

  var stateWithoutDeletedEntitiesByActivities = _objectSpread({}, state);

  var deletedActivityIdentifiers = [];
  var deletedActivityIdentifiersByStateKey = {};
  hydratedActivities.filter(function (activity) {
    return activity.verb === 'delete' || activity.patch && activity.patch.isSoftDeleted;
  }).forEach(function (activity) {
    var activityIdentifier = activity.entityIdentifier;
    var stateKey = activity.stateKey;
    deletedActivityIdentifiers.push(activityIdentifier);

    if (!deletedActivityIdentifiersByStateKey[stateKey]) {
      deletedActivityIdentifiersByStateKey[stateKey] = [activityIdentifier];
    } else {
      deletedActivityIdentifiersByStateKey[stateKey].push(activityIdentifier);
    }
  });
  Object.keys(deletedActivityIdentifiersByStateKey).forEach(function (stateKey) {
    if (!stateWithoutDeletedEntitiesByActivities[stateKey]) {
      return;
    }

    stateWithoutDeletedEntitiesByActivities[stateKey] = stateWithoutDeletedEntitiesByActivities[stateKey].filter(function (entity) {
      return !deletedActivityIdentifiersByStateKey[stateKey].includes(entity.activityIdentifier);
    });

    if (!stateWithoutDeletedEntitiesByActivities[stateKey].length) {
      delete stateWithoutDeletedEntitiesByActivities[stateKey];
    }
  });
  var notDeletedActivities = hydratedActivities.filter(function (activity) {
    return !deletedActivityIdentifiers.includes(activity.entityIdentifier);
  });
  var sortedActivities = notDeletedActivities.sort(function (activity1, activity2) {
    return new Date(activity1.dateCreated) < new Date(activity2.dateCreated) ? -1 : 1;
  });
  var firstDateCreatedsByIdentifier = {};
  var lastDateCreatedByIdentifier = {};
  sortedActivities.forEach(function (activity) {
    if (!firstDateCreatedsByIdentifier[activity.entityIdentifier]) {
      firstDateCreatedsByIdentifier[activity.entityIdentifier] = activity.dateCreated;
    }

    var lastDateCreated = lastDateCreatedByIdentifier[activity.entityIdentifier];

    if (lastDateCreated >= activity.dateCreated) {
      var dateTimePlusOneMillisecond = new Date(lastDateCreated).getTime() + 1;
      activity.dateCreated = new Date(dateTimePlusOneMillisecond).toISOString();
    }

    lastDateCreatedByIdentifier[activity.entityIdentifier] = activity.dateCreated;
  });
  return sortedActivities.reduce(function (aggregation, activity) {
    return _objectSpread(_objectSpread({}, aggregation), (0, _getNormalizedMergedState["default"])(aggregation, _defineProperty({}, activity.stateKey, [_objectSpread(_objectSpread({
      activityIdentifier: activity.entityIdentifier,
      firstDateCreated: firstDateCreatedsByIdentifier[activity.entityIdentifier],
      lastDateCreated: activity.dateCreated
    }, activity.patch), keepFromActivity(activity))]), {
      getDatumIdKey: function getDatumIdKey() {
        return 'activityIdentifier';
      },
      getDatumIdValue: function getDatumIdValue(entity) {
        return entity.activityIdentifier;
      },
      isMergingDatum: true
    }));
  }, _objectSpread(_objectSpread({}, stateWithoutDeletedEntitiesByActivities), hydratedPatch));
}

var _default = getNormalizedActivatedState;
exports["default"] = _default;